import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", as: Tag = "h1", delay = 0.1, onLoad = false }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px 0px" });
  const show = onLoad || inView;
  return (
    <Tag className={className} ref={ref}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: show ? 0 : "115%" }}
            transition={{ duration: 0.9, delay: delay + i * 0.13, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Eyebrow = ({ children, light = false }) => (
  <p className={`mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] ${light ? "text-teal-200" : "text-brand-teal"}`}>
    <span className={`h-px w-8 ${light ? "bg-teal-300" : "bg-brand-teal"}`} aria-hidden="true" />
    {children}
  </p>
);

export const Chapter = ({ number, label, light = false }) => (
  <div className="mb-6 flex items-end gap-4">
    <span className={`font-display text-5xl font-black leading-none ${light ? "text-white/25" : "text-outline"}`} aria-hidden="true">
      {number}
    </span>
    <Eyebrow light={light}>{label}</Eyebrow>
  </div>
);
